setTimeout(function () {
    // document.body.classList.add('--loaded');
    const preloader = document.getElementById('preloader');
    if (preloader) {
        preloader.classList.add('loaded');
    }
}, 200);

// IMAGE LOADER
const coImagesGlobalLoader = document.querySelectorAll('img.co-img-loader');
coImagesGlobalLoader.forEach((img) => {
    const coHandleImageLoad = () => {
        img.classList.add("co-img-loaded");
    };
    if (img.complete) {
        img.classList.add("co-img-completed");
    } else {
        img.addEventListener('load', coHandleImageLoad);
    }
});
//X IMAGE LOADER
